import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwHistoricoVendasAluno } from '../../../types/views/IVwHistoricoVendasAluno';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para histórico de vendas por aluno
 * Corresponde à view 'vw_historico_vendas_aluno' no banco de dados
 */
export class ViewHistoricoVendasAluno extends BaseMultiTenantService<IVwHistoricoVendasAluno[]> {
     constructor() {
          super('vw_historico_vendas_aluno', [], 'fk_id_organizacao');
     }

     /**
      * Histórico completo de vendas por aluno
      */
     async getHistoricoVendas(organizationId: number): Promise<PostgrestResponse<IVwHistoricoVendasAluno[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('data_venda', { ascending: false });
     }

     /**
      * Histórico de vendas de um aluno específico
      */
     async getHistoricoPorAluno(organizationId: number, alunoId: number, limite: number = 10): Promise<PostgrestResponse<IVwHistoricoVendasAluno[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId)
               .order('data_venda', { ascending: false })
               .limit(limite);
     }

     /**
      * Histórico de vendas por período
      */
     async getHistoricoPorPeriodo(organizationId: number, alunoId: number, dataInicio: string, dataFim: string): Promise<PostgrestResponse<IVwHistoricoVendasAluno[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId)
               .gte('data_venda', dataInicio)
               .lte('data_venda', dataFim)
               .order('data_venda', { ascending: false });
     }

     /**
      * Vendas de hoje por aluno
      */
     async getVendasHoje(organizationId: number, alunoId: number): Promise<PostgrestResponse<IVwHistoricoVendasAluno[]>> {
          const hoje = new Date().toISOString().split('T')[0];
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId)
               .eq('data_compra', hoje)
               .order('data_venda', { ascending: false });
     }

     /**
      * Estatísticas de compras por aluno
      */
     async getEstatisticasPorAluno(organizationId: number, alunoId: number): Promise<{
          totalCompras: number;
          valorTotal: number;
          valorMedio: number;
          ultimaCompra: string | null;
     }> {
          const { data } = await this.client
               .from(this.tableName)
               .select(`
                    venda_id.count(),
                    valor_item.sum(),
                    valor_item.avg(),
                    data_venda.max()
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_aluno', alunoId);

          return {
               totalCompras: data?.[0]?.count || 0,
               valorTotal: data?.[0]?.sum || 0,
               valorMedio: data?.[0]?.avg || 0,
               ultimaCompra: data?.[0]?.max ? String(data[0].max) : null
          };
     }
}

export const viewHistoricoVendasAluno = new ViewHistoricoVendasAluno();
